var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75429 2.85205C7.10455 2.04325 8.64891 1.61585 10.2229 1.61536C11.5324 1.61458 12.8252 1.9094 14.005 2.47783C15.1847 3.04625 16.221 3.87363 17.0364 4.89828C17.8519 5.92293 18.4256 7.11843 18.7147 8.39566C19.0038 9.67289 19.0009 10.9989 18.7062 12.2749C18.4115 13.5508 17.8327 14.7438 17.0127 15.7649C16.1928 16.786 15.153 17.6088 13.9708 18.1721C12.7885 18.7354 11.4944 19.0245 10.1849 19.0181C9.09195 19.0126 8.01177 18.8014 7.00033 18.3974L1.89273 19.2479C1.52075 19.3098 1.21671 18.9534 1.3365 18.5958L2.6664 14.6264C1.98869 13.4377 1.59943 12.1033 1.53404 10.7309C1.45913 9.15871 1.81206 7.59565 2.55525 6.20819C3.29843 4.82073 4.40403 3.66084 5.75429 2.85205Z",
    fill: "#84C70D",
    fillOpacity: 0.3,
    stroke: "#84C70D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6442 10.8434C14.4545 10.8434 14.3008 10.6897 14.3008 10.5C14.3008 10.3104 14.4545 10.1566 14.6442 10.1566",
    stroke: "#84C70D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6429 10.8434C14.8326 10.8434 14.9863 10.6897 14.9863 10.5C14.9863 10.3104 14.8326 10.1566 14.6429 10.1566",
    stroke: "#84C70D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3571 10.8434C10.1674 10.8434 10.0137 10.6897 10.0137 10.5C10.0137 10.3104 10.1674 10.1566 10.3571 10.1566",
    stroke: "#84C70D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3558 10.8434C10.5455 10.8434 10.6992 10.6897 10.6992 10.5C10.6992 10.3104 10.5455 10.1566 10.3558 10.1566",
    stroke: "#84C70D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07192 10.8434C5.88226 10.8434 5.72852 10.6897 5.72852 10.5C5.72852 10.3104 5.88226 10.1566 6.07192 10.1566",
    stroke: "#84C70D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07066 10.8434C6.26031 10.8434 6.41406 10.6897 6.41406 10.5C6.41406 10.3104 6.26031 10.1566 6.07066 10.1566",
    stroke: "#84C70D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupport);
export default __webpack_public_path__ + "static/media/customer-support.b7b6e328d8147dfa17368a7569fb1789.svg";
export { ForwardRef as ReactComponent };